// libs
import { useQuery } from '@apollo/client/react'
// graphql
import { INJURY_MASTER_IS_CONFIGURED_QUERY } from 'graphql/injuryMaster/queries'

// Integrations are only shown when at least one is actually connected — currently just Injury
// Master, more to follow.
export const useHasConnectedIntegrations = (): boolean => {
  const { data } = useQuery<{ injuryMasterIsConfigured: boolean }>(INJURY_MASTER_IS_CONFIGURED_QUERY)

  return data?.injuryMasterIsConfigured ?? false
}
